import { render, staticRenderFns } from "./FormListStickersComponent.vue?vue&type=template&id=5183ff16&"
import script from "./FormListStickersComponent.vue?vue&type=script&lang=js&"
export * from "./FormListStickersComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormListStickersComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports